import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { Contact } from "../../../../models/chemicalization/company";

interface ContactsModalProps {
  visible: boolean;
  onClose: () => void;
  contacts: Contact[];
}

export const DeleteContactModal: React.FC<ContactsModalProps> = ({ visible, onClose, contacts }) => {
  const { t } = useTranslation();

  return (
	<Modal
	  title={t("user.contacts")}
	  open={visible}
	  onCancel={onClose}
	  footer={null}
	  width={800}
	>
	  {contacts.length > 0 ? (
		<table style={{ width: "100%", borderCollapse: "collapse" }}>
		  <thead>
		  <tr>
			<th style={{ padding: "8px", border: "1px solid #ddd", backgroundColor: "#f4f4f4" }}>
			  {t("user.full_name")}
			</th>
			<th style={{ padding: "8px", border: "1px solid #ddd", backgroundColor: "#f4f4f4" }}>
			  {t("user.phone_number")}
			</th>
			<th style={{ padding: "8px", border: "1px solid #ddd", backgroundColor: "#f4f4f4" }}>
			  {t("user.email")}
			</th>
		  </tr>
		  </thead>
		  <tbody>
		  {contacts.map((contact) => (
			<tr key={contact.id}>
			  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{contact.contactName}</td>
			  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{contact.phone}</td>
			  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{contact.email}</td>
			</tr>
		  ))}
		  </tbody>
		</table>
	  ) : (
		t("user.no_contacts")
	  )}
	</Modal>
  );
};
